module.exports = __webpack_public_path__ + "static/media/coachbox-logo-mail@2x.27a3dc65.png";